import MUIMenuItem, { MenuItemProps } from '@mui/material/MenuItem';
import cx from 'classnames';

const Menu = ({ className, ...props }: MenuItemProps) => {
  return <MUIMenuItem className={cx(className)} {...props} />;
};

export default Menu;
